export default __webpack_public_path__ + "6cd818732322ac41226d7ed207d35a90.jpg";